import React from 'react'

const Seperator = () => {
    return (
        <div className="container">
            <div className='seperator-content'>
                <img src="https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/Asset-31@4x.png" alt="" />
            </div>
        </div>
    )
}

export default Seperator